import React, { useEffect, useState } from "react";
import LogoPrideCom from "../../assets/imgs/R_C.png";
import { ModalContact } from "../../components/modalContact/modalContact";
import "./footer.scss";
import { Link } from "react-router-dom";
import JSONSocialMedia from "../../assets/jsons/listSocialMedia.json";
import { FaFacebookF, FaXTwitter } from "react-icons/fa6";
import {
  FaEnvelope,
  FaInstagram,
  FaLinkedinIn,
  FaTiktok,
  FaWhatsapp,
  FaYoutube,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { ColorStripe } from "../colorStripe/colorStripe";
import { WrapperChats } from "../wrapperChats/wrapperChats";
import { useValidTokenFromStorage } from "../../hooks/authHook";

export const FooterFull = () => {
  const validateToken = useValidTokenFromStorage();
  const [listSocialMedia, setListSocialMedia] = useState([]);
  const iconMap = {
    FaFacebookF: FaFacebookF,
    FaInstagram: FaInstagram,
    FaXTwitter: FaXTwitter,
    FaYoutube: FaYoutube,
    FaTiktok: FaTiktok,
    FaLinkedinIn: FaLinkedinIn,
  };

  useEffect(() => {
    setListSocialMedia(JSONSocialMedia);
  }, []);

  return (
    <footer className="footer">
      <ColorStripe />
      <div className="container-page">
        <div className="footer__top">
          <div className="logo">
            <Link to="/home">
              <img
                className="logo_brand"
                src={LogoPrideCom}
                alt="PrideMx, Todo el poder de la comunidad en un solo espacio"
              />
            </Link>
          </div>
          <div className="contact">
            <h6 className="mb-3">Contacto</h6>
            <div className="contact_content text-left">
              <p className="mb-0 mt-1">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://wa.me/5650334644"
                >
                  <FaWhatsapp /> <span>(565) 033 4644</span>
                </a>
              </p>
              <p className="mb-0 mt-1">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="mailto:contacto@pridemx.com"
                >
                  <FaEnvelope /> <span>contacto@pridemx.com</span>
                </a>
              </p>
              <p className="mb-0 mt-1">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://maps.app.goo.gl/5BAqV9Qmbb9Xu1tV9"
                >
                  <FaMapMarkerAlt />{" "}
                  <span>
                    C. Texas 39, Nápoles, Benito Juárez, 03810 Ciudad de México,
                    CDMX
                  </span>
                </a>
              </p>
            </div>
          </div>
          <div className="social-media">
            <h6 className="mb-3">Síguenos en</h6>
            <ul>
              {listSocialMedia?.map((item, i) => {
                const IconComponent = iconMap[item.icon];
                return (
                  <li key={i}>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className={item.name}
                      href={item.url}
                      key={i}
                    >
                      {IconComponent ? <IconComponent /> : null}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div className="footer__bottom">
          <small>
            {new Date().getFullYear()} ©PrideMx. Todos los derechos reservados
          </small>
          <ul>
            <li>
              <ModalContact />
            </li>
            <li>
              <a target="_blank" href="/ambienteseguro.pdf">
                Decálogo
              </a>
            </li>
            <li>
              <a
                className="link_footer"
                target="_blank"
                href="/avisoprivacidad.pdf"
              >
                Aviso de Privacidad
              </a>
            </li>
            <li>
              <a
                className="link_footer"
                target="_blank"
                href="/terminosycondiciones.pdf"
              >
                Términos y Condiciones
              </a>
            </li>
          </ul>
        </div>
      </div>
      {validateToken ? <WrapperChats /> : null}
    </footer>
  );
};
